import ResponseHelper from '@/helpers/responseHelper';
import ExceptionHelper from '@/helpers/exceptionHelper';
import api from '@/store/api';
import mixinHelper from '@/helpers/mixinHelper';

export default {
  // #region : Actions :
  /**
   * Sets the quantity formula
   *
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  testQuantityFormula: ({ commit }, payload) => {
    const url = '/Configurator/TestSubsystemFormula';
    let params = {};

    // set values
    params.subsystemId = payload.subsystemId;
    params.formula = payload.formula;

    try {
      return api
        .post(url, params)
        .then((response) => {
          const valid = ResponseHelper.processResponse(
            response,
            commit,
            'testQuantityFormula'
          );

          if (valid && response.data.result) {
            return { success: true, response: response.data.result };
          }
        })
        .catch((error) => {
          if (error.response && error.response.data.userMessage)
            return {
              success: false,
              response: error.response.data.userMessage
            };
          else return { success: false, response: error };
        });
    } catch (ex) {
      ExceptionHelper.handleError(ex);
    }
  },
  // #endregion

  // #region : Copy Entities :
  /**
   * Copies a product based on input payload
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  copyProduct: ({ state, commit }, payload) => {
    commit('setProductsLoading', true);

    const url = '/Product/Copy';
    let params = {};

    // set values
    params.id = payload.id;
    params.sku = payload.sku;
    params.includeAttributes = payload.includeAttributes;
    params.includeAccessories = payload.includeAccessories;
    params.includeRequirements = payload.includeRequirements;
    params.includeSettings = payload.includeSettings;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'copyProduct'
        );

        if (valid) {
          return response.data;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  // #endregion

  // #region : Entity Lists :
  /**
   * Returns a list of all defined users
   *
   * @param {*} param0
   * @returns
   */
  getUserList: ({ commit }) => {
    commit('setUserListLoading', true);

    const url = '/User/List';

    try {
      return api.get(url).then((response) => {
        commit('setUserListLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getUserList'
        );

        if (valid) {
          commit('setUserList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setUserListLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Returns a list of Subsystems for input userId
   *
   * @param {*} param0
   * @param {*} userId
   * @returns
   */
  getSubsystemByUserList: ({ commit }, userId) => {
    commit('setSubsystemByUserListLoading', true);

    const url = `/Subsystem/ListByUser/${userId}`;

    try {
      return api.get(url).then((response) => {
        commit('setSubsystemByUserListLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getSubsystemByUserList'
        );

        if (valid) {
          commit('setSubsystemByUserList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSubsystemByUserListLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Returns a list of all defined systems
   * @param {*} state
   */
  getSystemList: ({ state, commit }) => {
    commit('setSystemsLoading', true);

    try {
      return api.get('/SystemDefinition/List').then((response) => {
        commit('setSystemsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getSystemList'
        );

        if (valid) {
          commit('setSystemList', response.data);
          // refresh selected system
          if (state.selectedSystem)
            commit(
              'setSelectedSystem',
              state.systemList.find((x) => x.id == state.selectedSystem.id)
            );
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSystemsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Returns a list of Subsystems for input SystemId
   * @param {*} state
   * @param {*} systemId
   */
  getSubsystemsBySystemId: ({ state, commit }, systemId) => {
    commit('setSubsystemsLoading', true);

    const url = `/SubsystemDefinition/List/${systemId}`;

    try {
      return api.get(url).then((response) => {
        commit('setSubsystemsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getSubsystemsBySystemId'
        );

        if (valid) {
          commit('setSubsystemList', response.data);
          // refresh selected subsystem
          if (state.selectedSubsystem)
            commit(
              'setSelectedSubsystem',
              state.subsystemList.find(
                (x) => x.id == state.selectedSubsystem.id
              )
            );
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSubsystemsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Returns a list of components by Subsystem
   * @param {*} param0
   */
  getComponentsBySubsystemId: ({ state, commit }, subsystemId) => {
    commit('setComponentsLoading', true);

    const url = `/ComponentDefinition/List/${subsystemId}`;

    try {
      return api.get(url).then((response) => {
        commit('setComponentsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getComponentsBySubsystemId'
        );

        if (valid) {
          commit('setComponentList', response.data);
          // refresh selected component
          if (state.selectedComponent)
            commit(
              'setSelectedComponent',
              state.componentList.find(
                (x) => x.id == state.selectedComponent.id
              )
            );
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets list of products
   * @param {*} param0
   */
  getProductList: ({ commit }) => {
    commit('setProductsLoading', true);

    const url = '/Product/List';

    try {
      return api.get(url).then((response) => {
        commit('setProductsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductList'
        );

        if (valid) {
          commit('setProductList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets list of
   * @param {*} param0
   */
  getAttributeList: ({ commit }) => {
    commit('setAttributesLoading', true);

    const url = '/Attribute/List';

    try {
      return api.get(url).then((response) => {
        commit('setAttributesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getAttributeList'
        );

        if (valid) {
          commit('setAttributeList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setAttributesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets list of sellAsTypes
   * @param {   */
  getSellAsTypeList: ({ commit }) => {
    commit('setSellAsTypeListLoading', true);

    const url = '/Product/SellAsTypeList';

    try {
      return api.get(url).then((response) => {
        commit('setSellAsTypeListLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getSellAsTypeList'
        );

        if (valid) {
          commit('setSellAsTypeList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSellAsTypeListLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets the Attribute Value List
   * @param {*} param0
   */
  getAttributeValueList: ({ state, commit }, attributeId) => {
    commit('setAttributeValuesLoading', true);

    // clear any Attribute Selection Models that dont match the selectedAttribute to avoid conflicts
    // since admin.attributeValueList is shared by multiple controls
    if (state.selectedProductAttributeValue?.attributeId != attributeId) {
      commit('setSelectionModel', {
        entity: 'selectedProductAttributeValueSelectionModel',
        value: null
      });
      commit('setSelectedProductAttributeValue', null);
    }
    if (state.selectedAttribute?.id != attributeId) {
      commit('setSelectionModel', {
        entity: 'selectedAttributeSelectionModel',
        value: null
      });
      commit('setSelectedAttribute', null);
      commit('setCurrentAttributeTab', state.PRODUCT_TABS.LIST);
    }
    if (state.selectedProductRequirement?.attributeId != attributeId) {
      commit('setSelectionModel', {
        entity: 'selectedProductRequirementSelectionModel',
        value: null
      });
      commit('setSelectedProductRequirement', null);
    }

    const url = `/AttributeValue/List/${attributeId}`;

    try {
      return api.get(url).then((response) => {
        commit('setAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getAttributeValueList'
        );

        if (valid) {
          commit('setAttributeValueList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of productAttributeValues by product id
   * @param {*} param0
   */
  getProductAttributeValueList: ({ state, commit }) => {
    commit('setProductAttributeValuesLoading', true);

    const url = `/ProductAttributeValue/List/${state.selectedProduct.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setProductAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductAttributeValueByProductId'
        );

        if (valid) {
          commit('setProductAttributeValueList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of productAttributeValues by product id
   * @param {*} param0
   */
  getProductAccessoryList: ({ state, commit }) => {
    commit('setProductAccessoriesLoading', true);

    const url = `/ProductAccessory/List/${state.selectedProduct.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setProductAccessoriesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductAccessoryList'
        );

        if (valid) {
          commit('setProductAccessoryList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAccessoriesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of product requirements
   * @param {*} param0
   */
  getProductRequirementList: ({ state, commit }) => {
    commit('setProductRequirementsLoading', true);

    const url = `/ProductRequirement/List/${state.selectedProduct.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setProductRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductRequirementList'
        );

        if (valid) {
          commit('setProductRequirementList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of product requirements
   * @param {*} param0
   */
  getProductSettingList: ({ state, commit }) => {
    commit('setProductSettingsLoading', true);

    const url = `/ProductSetting/List/${state.selectedProduct.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setProductSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductSettingList'
        );

        if (valid) {
          commit('setProductSettingList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Returns a list of product types
   * @param {*} param0
   */
  getProductTypeList: ({ commit }) => {
    commit('setProductTypesLoading', true);

    const url = '/ProductType/List';

    try {
      return api.get(url).then((response) => {
        commit('setProductTypesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProductTypeList'
        );

        if (valid) {
          commit('setProductTypeList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductTypesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets list of control teypes
   * @param {*} param0
   */
  getControlTypeList: ({ commit }) => {
    commit('setControlTypesLoading', true);

    const url = '/Attribute/ControlTypeList';

    try {
      return api.get(url).then((response) => {
        commit('setControlTypesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getControlTypeList'
        );

        if (valid) {
          commit('setControlTypeList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setControlTypesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets list of requirementTypes
   * @param {*} param0
   */
  getRequirementTypeList: ({ commit }) => {
    commit('setRequirementTypesLoading', true);

    const url = '/ProductRequirement/RequirementTypeList';

    try {
      return api.get(url).then((response) => {
        commit('setRequirementTypesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getRequirementTypeList'
        );

        if (valid) {
          commit('setRequirementTypeList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setRequirementTypesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of component requirements
   * @param {*} param0
   */
  getComponentRequirementList: ({ state, commit }) => {
    commit('setComponentRequirementsLoading', true);

    const url = `/ComponentDefinitionRequirement/List/${state.selectedComponent.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setComponentRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getComponentRequirementList'
        );

        if (valid) {
          commit('setComponentRequirementList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of component requirements
   * @param {*} param0
   */
  getComponentSettingList: ({ state, commit }) => {
    commit('setComponentSettingsLoading', true);

    const url = `/ComponentSettingDefinition/List/${state.selectedComponent.id}`;

    try {
      return api.get(url).then((response) => {
        commit('setComponentSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getComponentSettingList'
        );

        if (valid) {
          commit('setComponentSettingList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of project settings
   * @param {*} param0
   */
  getProjectSettingList: ({ commit }) => {
    commit('setProjectSettingsLoading', true);

    const url = '/ProjectSettingDefinition/List';

    try {
      return api.get(url).then((response) => {
        commit('setProjectSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getProjectSettingList'
        );

        if (valid) {
          commit('setProjectSettingList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProjectSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets a list of requirement entities
   * @param {*} param0
   * @returns
   */
  getRequirementEntityList: ({ commit }) => {
    const url = '/ProductRequirement/RequirementEntityList';

    try {
      return api.get(url).then((response) => {
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getRequirementEntityList'
        );

        if (valid) {
          commit('setRequirementEntityList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets an image list for a given product
   * @param {*} param0
   * @param {*} productId
   * @returns
   */
  getImageList: ({ commit }, productId) => {
    commit('setProductImagesLoading', true);

    const url = `/ProductImage/List/${productId}`;

    try {
      return api.get(url).then((response) => {
        commit('setProductImagesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'getImageList'
        );

        if (valid) {
          commit('setProductImageList', response.data);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductImagesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Gets the UserType List
   * @param {*} param0
   * @returns
   */
  getUserTypeList: ({ commit }) => {
    const url = '/ProjectSettingDefinition/Values/UserType';

    return api.get(url).then((response) => {
      const valid = ResponseHelper.processResponse(
        response,
        commit,
        'getUserTypeList'
      );

      if (valid) {
        commit('setUserTypeList', response.data);
      } else {
        return response.Errors;
      }
    });
  },
  // #endregion

  // #region : Save Entities
  /**
   * Create/Update a System
   * @param {*} param0
   * @param {*} param1
   */
  saveSelectedSystem: ({ state, commit }) => {
    commit('setSystemsLoading', true);

    const isCreate = isNaN(state.selectedSystem.id);
    const url = isCreate
      ? '/SystemDefinition/Create'
      : '/SystemDefinition/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedSystem.id;

    // set values
    params.name = state.selectedSystem.name;
    params.description = state.selectedSystem.description;
    params.systemType = state.selectedSystem.systemType;
    params.published = state.selectedSystem.published;

    try {
      return api.post(url, params).then((response) => {
        commit('setSystemsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedSystem'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSystemsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the currently edited subsystem
   * @param {*} param0
   */
  saveSelectedSubsystem: ({ state, commit }) => {
    commit('setSubsystemsLoading', true);

    const isCreate = isNaN(state.selectedSubsystem.id);
    const url = isCreate
      ? '/SubsystemDefinition/Create'
      : '/SubsystemDefinition/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedSubsystem.id;

    // set values
    params.systemDefinitionId = state.selectedSubsystem.systemDefinitionId;
    params.name = state.selectedSubsystem.name;
    params.description = state.selectedSubsystem.description;
    params.subsystemType = state.selectedSubsystem.subsystemType;
    params.userType = state.selectedSubsystem.userType;
    params.published = state.selectedSubsystem.published;

    try {
      return api.post(url, params).then((response) => {
        commit('setSubsystemsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedSubsystem'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSubsystemsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the currently edited component
   * @param {*} param0
   */
  saveSelectedComponent: ({ state, commit }) => {
    commit('setComponentsLoading', true);

    const isCreate = isNaN(state.selectedComponent.id);
    const url = isCreate
      ? '/ComponentDefinition/Create'
      : '/ComponentDefinition/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedComponent.id;

    // set values
    params.subsystemDefinitionId =
      state.selectedComponent.subsystemDefinitionId;
    params.name = state.selectedComponent.name;
    params.description = state.selectedComponent.description;
    params.productTypeId =
      state.selectedComponent.productTypeId == ''
        ? null
        : state.selectedComponent.productTypeId;
    params.sequence = state.selectedComponent.sequence;
    params.sigMessage = state.selectedComponent.sigMessage;
    params.stepLabel = state.selectedComponent.stepLabel;
    params.maxQuantity = state.selectedComponent.maxQuantity;
    params.defaultQuantityFromSetting =
      state.selectedComponent.defaultQuantityFromSetting;
    params.published = state.selectedComponent.published;

    try {
      return api.post(url, params).then((response) => {
        commit('setComponentsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedComponent'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedComponent',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Upsert a Product
   * @param {*} param0
   * @returns
   */
  saveSelectedProduct: ({ state, commit }) => {
    commit('setProductsLoading', true);

    const isCreate = isNaN(state.selectedProduct.id);
    const url = isCreate ? '/Product/Create' : '/Product/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProduct.id;

    // set values
    params.sku = state.selectedProduct.sku;
    params.name = state.selectedProduct.name;
    params.description = state.selectedProduct.description;
    params.longDescription = state.selectedProduct.longDescription;
    params.productTypeId = state.selectedProduct.productTypeId;
    params.sellPrice = state.selectedProduct.sellPrice;
    params.published = state.selectedProduct.published;
    params.variantOfProductId =
      state.selectedProduct.variantOfProductId == 0
        ? null
        : state.selectedProduct.variantOfProductId;
    params.sellAsType = state.selectedProduct.sellAsType;
    params.quantityFormula = state.selectedProduct.quantityFormula;
    params.quantityFormulaDescription =
      state.selectedProduct.quantityFormulaDescription;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProduct'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Upsert a ProductAttributeValue
   * @param {*} param0
   * @returns
   */
  saveSelectedProductAttributeValue: ({ state, commit }) => {
    commit('setProductAttributeValuesLoading', true);

    const isCreate = isNaN(state.selectedProductAttributeValue.id);
    const url = isCreate
      ? '/ProductAttributeValue/Create'
      : '/ProductAttributeValue/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProductAttributeValue.id;

    // set values
    params.productId = state.selectedProduct.id;
    params.attributeId = state.selectedProductAttributeValue.attributeId;
    // array handling for value
    params.value = Array.isArray(state.selectedProductAttributeValue.value)
      ? state.selectedProductAttributeValue.value.join(',')
      : state.selectedProductAttributeValue.value;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProductAttributeValue'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProductAttributeValue',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Upsert a ProductAccessory
   * @param {*} param0
   * @returns
   */
  saveSelectedProductAccessory: ({ state, commit }) => {
    commit('setProductAccessoriesLoading', true);

    const isCreate = isNaN(state.selectedProductAccessory.id);
    const url = isCreate
      ? '/ProductAccessory/Create'
      : '/ProductAccessory/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProductAccessory.id;

    // set values
    params.productId = state.selectedProductAccessory.productId;
    params.parentProductId = state.selectedProduct.id;
    params.minQuantity = state.selectedProductAccessory.minQuantity;
    params.maxQuantity = state.selectedProductAccessory.maxQuantity;
    params.required = state.selectedProductAccessory.required;
    params.configurable = state.selectedProductAccessory.configurable;
    params.defaultToParentQuantity =
      state.selectedProductAccessory.defaultToParentQuantity;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductAccessoriesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProductAccessory'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAccessoriesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the current selectedProductRequirement
   * @param {*} param0
   */
  saveSelectedProductRequirement: ({ state, commit }) => {
    commit('setProductRequirementsLoading', true);

    const isCreate = isNaN(state.selectedProductRequirement.id);
    const url = isCreate
      ? '/ProductRequirement/Create'
      : '/ProductRequirement/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProductRequirement.id;

    // set values
    params.productId = state.selectedProduct.id;
    params.childProductTypeId =
      state.selectedProductRequirement.childProductTypeId;
    params.attributeId = state.selectedProductRequirement.attributeId;
    params.requirementType = state.selectedProductRequirement.requirementType;
    params.value = state.selectedProductRequirement.value;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProductRequirement'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProductRequirement',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the current selectedProductSetting
   * @param {*} param0
   */
  saveSelectedProductSetting: ({ state, commit }) => {
    commit('setProductSettingsLoading', true);

    const isCreate = isNaN(state.selectedProductSetting.id);
    const url = isCreate ? '/ProductSetting/Create' : '/ProductSetting/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProductSetting.id;

    // set values
    params.productId = state.selectedProductSetting.productId;
    params.attributeId = state.selectedProductSetting.attributeId;
    params.label = state.selectedProductSetting.label;
    params.valueSuffix = state.selectedProductSetting.valueSuffix;
    params.published = state.selectedProductSetting.published;
    params.sigMessage = state.selectedProductSetting.sigMessage;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProductSetting'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProductSetting',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Upsert an Attribute
   * @param {*} param0
   */
  saveSelectedAttribute: ({ state, commit }) => {
    commit('setAttributesLoading', true);

    const isCreate = isNaN(state.selectedAttribute.id);
    const url = isCreate ? '/Attribute/Create' : '/Attribute/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedAttribute.id;

    // set values
    params.name = state.selectedAttribute.name;
    params.description = state.selectedAttribute.description;
    params.controlType = state.selectedAttribute.controlType;
    params.sigMessage = state.selectedAttribute.sigMessage;

    try {
      return api.post(url, params).then((response) => {
        commit('setAttributesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedAttribute'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setAttributesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Upsert an Attribute Value
   * @param {*} param0
   */
  saveSelectedAttributeValue: ({ state, commit }) => {
    commit('setAttributeValuesLoading', true);

    const isCreate = isNaN(state.selectedAttributeValue.id);
    const url = isCreate ? '/AttributeValue/Create' : '/AttributeValue/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedAttributeValue.id;

    // set values
    params.attributeId = state.selectedAttributeValue.attributeId;
    params.label = state.selectedAttributeValue.label;
    params.value = state.selectedAttributeValue.value;
    params.published = state.selectedAttributeValue.published;

    try {
      return api.post(url, params).then((response) => {
        commit('setAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedAttributeValue'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the current selectedComponentRequirement
   * @param {*} param0
   */
  saveSelectedComponentRequirement: ({ state, commit }) => {
    commit('setComponentRequirementsLoading', true);

    const isCreate = isNaN(state.selectedComponentRequirement.id);
    const url = isCreate
      ? '/ComponentDefinitionRequirement/Create'
      : '/ComponentDefinitionRequirement/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedComponentRequirement.id;

    // set values
    params.componentDefinitionId = state.selectedComponent.id;
    params.attributeId = state.selectedComponentRequirement.attributeId;
    params.requirementType = state.selectedComponentRequirement.requirementType;
    params.value = state.selectedComponentRequirement.value;
    params.componentSettingDefinitionId =
      state.selectedComponentRequirement.componentSettingDefinitionId;
    params.targetEntity = state.selectedComponentRequirement.targetEntity;

    try {
      return api.post(url, params).then((response) => {
        commit('setComponentRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedComponentRequirement'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the current selectedComponentSetting
   * @param {*} param0
   */
  saveSelectedComponentSetting: ({ state, commit }) => {
    commit('setComponentSettingsLoading', true);

    const isCreate = isNaN(state.selectedComponentSetting.id);
    const url = isCreate
      ? '/ComponentSettingDefinition/Create'
      : '/ComponentSettingDefinition/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedComponentSetting.id;

    // set values
    params.componentDefinitionId = state.selectedComponent.id;
    params.attributeId = state.selectedComponentSetting.attributeId;
    params.label = state.selectedComponentSetting.label;
    params.valueSuffix = state.selectedComponentSetting.valueSuffix;
    params.required = state.selectedComponentSetting.required;
    params.published = state.selectedComponentSetting.published;
    params.sigMessage = state.selectedComponentSetting.sigMessage;

    try {
      return api.post(url, params).then((response) => {
        commit('setComponentSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedComponentSetting'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the current selectedProjectSetting
   * @param {*} param0
   */
  saveSelectedProjectSetting: ({ state, commit }) => {
    commit('setProjectSettingsLoading', true);

    const isCreate = isNaN(state.selectedProjectSetting.id);
    const url = isCreate
      ? '/ProjectSettingDefinition/Create'
      : '/ProjectSettingDefinition/Update';
    let params = {};
    if (!isCreate) params.id = state.selectedProjectSetting.id;

    // set values
    params.attributeId = state.selectedProjectSetting.attributeId;
    params.label = state.selectedProjectSetting.label;
    params.valueSuffix = state.selectedProjectSetting.valueSuffix;
    params.published = state.selectedProjectSetting.published;

    try {
      return api.post(url, params).then((response) => {
        commit('setProjectSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveSelectedProjectSetting'
        );

        if (valid) {
          commit('updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'id',
            value: response.data.id
          });
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProjectSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves images to the product controller
   * @param {*} param0
   */
  saveProductImages: ({ state, dispatch, commit }, files) => {
    commit('setProductImagesLoading', true);

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('productId', state.selectedProduct.id);
    formData.append('imageType', 'Secondary');
    formData.append('displayOrder', 99);

    const url = '/ProductImage/UploadProductImages';
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    try {
      return api.post(url, formData, config).then(() => {
        commit('setProductImagesLoading', false);
        dispatch('getImageList', state.selectedProduct.id);
      });
    } catch (ex) {
      commit('setProductImagesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Saves the product details pdf for a product
   *
   * @param {*} param0
   * @param {*} file
   * @returns
   */
  saveProductDetails: ({ state, dispatch, commit }, file) => {
    commit('setProductDetailsLoading', true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('productId', state.selectedProduct.id);

    const url = '/Product/UploadProductDetails';
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    try {
      return api.post(url, formData, config).then(() => {
        commit('setProductDetailsLoading', false);
        dispatch('getProductList').then(() => {
          commit(
            'setSelectedProduct',
            state.productList.find((x) => x.id == state.selectedProduct.id)
          );
        });
      });
    } catch (ex) {
      commit('setProductDetailsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Reorders existing images
   * @param {*} param0
   * @returns
   */
  saveImageOrder: ({ state, commit, dispatch }) => {
    commit('setProductImagesLoading', true);

    const url = '/ProductImage/Reorder';
    let params = state.productImageList;

    try {
      return api.post(url, params).then((response) => {
        commit('setProductImagesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'saveImageOrder'
        );

        if (valid) {
          dispatch('getImageList', state.selectedProduct.id);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductImagesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  // #endregion

  // #region : Delete Entities
  /**
   * Deletes the currently selected system
   * @param {*} param0
   */
  deleteSelectedSystem: ({ state, commit }) => {
    commit('setSystemsLoading', true);

    const url = `/SystemDefinition/Delete/${state.selectedSystem.id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setSystemsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteSelectedSystem'
        );

        if (valid) {
          // show success
          commit('setSelectedSystem', null);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setSystemsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes the currently selected component
   * @param {*} param0
   */
  deleteSelectedComponent: ({ state, commit }) => {
    commit('setComponentsLoading', true);

    const url = `/ComponentDefinition/Delete/${state.selectedComponent.id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setComponentsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteSelectedComponent'
        );

        if (valid) {
          // show success
          commit('setSelectedSystem', null);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes the currently selected attribute value
   * @param {*} param0
   */
  deleteSelectedAttributeValue: ({ state, commit }) => {
    commit('setAttributeValuesLoading', true);

    const url = `/AttributeValue/Delete/${state.selectedAttributeValue.id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteSelectedAttributeValue'
        );

        if (valid) {
          // show success
          commit('setSelectedSystem', null);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product requirement
   * @param {*} param0
   * @param {*} id
   */
  deleteProductRequirement: ({ commit }, id) => {
    commit('setProductRequirementsLoading', true);

    const url = `/ProductRequirement/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductRequirement'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product accessory
   * @param {*} param0
   * @param {*} id
   */
  deleteProductAccessory: ({ commit }, id) => {
    commit('setProductAccessoriesLoading', true);

    const url = `/ProductAccessory/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductAccessoriesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductAccessory'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAccessoriesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product setting
   * @param {*} param0
   * @param {*} id
   */
  deleteProductSetting: ({ commit }, id) => {
    commit('setProductSettingsLoading', true);

    const url = `/ProductSetting/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductSetting'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product attribute value
   * @param {*} param0
   * @param {*} id
   */
  deleteProductAttributeValue: ({ commit }, id) => {
    commit('setProductAttributeValuesLoading', true);

    const url = `/ProductAttributeValue/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductAttributeValuesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductAttributeValue'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductAttributeValuesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product requirement
   * @param {*} param0
   * @param {*} id
   */
  deleteComponentRequirement: ({ commit }, id) => {
    commit('setComponentRequirementsLoading', true);

    const url = `/ComponentDefinitionRequirement/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setComponentRequirementsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteComponentRequirement'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentRequirementsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product setting
   * @param {*} param0
   * @param {*} id
   */
  deleteComponentSetting: ({ commit }, id) => {
    commit('setComponentSettingsLoading', true);

    const url = `/ComponentSettingDefinition/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setComponentSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteComponentSetting'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setComponentSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes a product setting
   * @param {*} param0
   * @param {*} id
   */
  deleteProjectSetting: ({ commit }, id) => {
    commit('setProjectSettingsLoading', true);

    const url = `/ProjectSettingDefinition/Delete/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProjectSettingsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProjectSetting'
        );

        if (valid) {
          return;
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProjectSettingsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes image indicated by input ID
   * @param {*} param0
   * @param {*} imageId
   * @returns
   */
  deleteProductImage: ({ state, dispatch, commit }, imageId) => {
    commit('setProductImagesLoading', true);

    const url = `/ProductImage/Delete/${imageId}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductImagesLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductImage'
        );

        if (valid) {
          dispatch('getImageList', state.selectedProduct.id);
        } else {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductImagesLoading', false);
      ExceptionHelper.handleError(ex);
    }
  },
  /**
   * Deletes the product details pdf for a product
   *
   * @param {*} param0
   * @param {*} id
   * @returns
   */
  deleteProductDetails: ({ state, dispatch, commit }, id) => {
    commit('setProductDetailsLoading', true);

    const url = `/Product/DeleteProductDetails/${id}`;

    try {
      return api.delete(url).then((response) => {
        commit('setProductDetailsLoading', false);
        const valid = ResponseHelper.processResponse(
          response,
          commit,
          'deleteProductDetails'
        );
        dispatch('getProductList').then(() => {
          commit(
            'setSelectedProduct',
            state.productList.find((x) => x.id == state.selectedProduct.id)
          );
        });
        if (!valid) {
          return response.Errors;
        }
      });
    } catch (ex) {
      commit('setProductDetailsLoading', false);
      ExceptionHelper.handleError(ex);
    }
  }
  // #endregion
};
